module.exports = __webpack_public_path__ + "img/invisible.e683c175.svg";